<div fxLayout="column" fxHide.lt-md>
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else quickpaypaymentAmountFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <ng-container *ngTemplateOutlet="quickpaypaymentAmountFlexColumnTemplate"></ng-container>
  </div>
</div>

<div fxLayout="column" fxHide.gt-sm ngStyle.lt-md="padding-left: 8px; padding-right: 8px">
    <div fxFlex.lt-sm="10px" fxFlex.gt-sm="25px">&nbsp;</div>
    <ng-container *ngTemplateOutlet="quickpaypaymentAmountCardViewTemplate"></ng-container>
</div>

<ng-template #quickpaypaymentAmountCardViewTemplate>
    <div fxLayout="column">

        <ng-container *ngFor="let row of openNotesQuickPayPaymentInfoListWithFooters">
            <ng-container *ngIf="row.hasOwnProperty('isGroupFooter')">
                <mat-card
                    style="background-color: #e3f2fd;">
                    <mat-card-content>

                        <div style="display: flex; justify-content: space-between;">
                            <mat-label><span class="header-superscript header-after-content-3"
                                    [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                    i18n="@@payment-note-list.table.column-header.total-amount-due">payment-note-list.table.column-header.total-amount-due</span></mat-label>
                            <span style="text-align: right;">{{
                                row.totalAmountDueTotal | currency
                                }}</span>
                        </div>

                    </mat-card-content>
                </mat-card>
            </ng-container>

            <ng-container *ngIf="!row.hasOwnProperty('isGroupFooter')">
                <mat-card *ngIf="row.noteId">
                    <mat-card-content>
                        <div style="width: 100%;">
                            <!-- Left Section: Note ID and Note Status -->
                            <div>
                                <mat-card-title>{{ row.noteId }}
                                </mat-card-title>
                                
                                <div style="display: flex; justify-content: space-between;">
                                    <mat-label><span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                            i18n="@@payment-note-list.table.column-header.next-payment-due-date">payment-note-list.table.column-header.next-payment-due-date</span></mat-label>
                                    <span style="text-align: right;">{{ row.nextPaymentDueDate }}</span>
                                </div>
                                <div style="display: flex; justify-content: space-between;">
                                    <mat-label><span class="header-superscript header-after-content-3"
                                            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                            i18n="@@payment-note-list.table.column-header.total-amount-due">payment-note-list.table.column-header.total-amount-due</span></mat-label>
                                    <span style="text-align: right;">{{
                                        row.totalAmountDue | currency
                                        }}</span>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </ng-container>

        </ng-container>
    </div>
    <div fxLayout="column" style="margin-top: 16px" *ngIf="openNotesPaymentInfoListFound && displayNotices">
        <div *ngIf="isBrowserIE; else paymentNoteListNoticesFlexColumnTemplate"
            [ngClass]="{ 'ie-display': isBrowserIE }">
            <ng-container *ngTemplateOutlet="quickpaypaymentNoteListNoticesFlexColumnTemplate"></ng-container>
        </div>
    </div>

        <div fxLayout="column" style="margin-top: 16px" *ngIf="quickpaypaymentSelectedDataFound">
      <div *ngIf="isBrowserIE; else quickpaypaymentAmountPostTableFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="quickpaypaymentAmountPostTableFlexColumnTemplate"></ng-container>
      </div>
    </div>
</ng-template>

<ng-template #quickpaypaymentAmountFlexColumnTemplate>
  <div fxLayout="column">
    <div *ngIf="isBrowserIE; else quickpaypaymentAmountTableFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
      <ng-container *ngTemplateOutlet="quickpaypaymentAmountTableFlexColumnTemplate"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #quickpaypaymentAmountTableFlexColumnTemplate>
  <div fxFlex="100%" class="display-text primary-dark-color-important" *ngIf="displayTitle">
    <b><span i18n="@@quick-pay-payment-amount.table.title">quick-pay-payment-amount.table.title</span></b>
  </div>

  <div fxFlex="100%" class="display-text title-spacer" *ngIf="!quickpaypaymentSelectedDataFound">
    <i><span i18n="@@quick-pay-payment-amount.table.no-records">quick-pay-payment-amount.table.no-records</span></i>
  </div>

  <div fxFlex="100%" [ngStyle]="{ display: tableDisplayStyle }">
    <mat-table #table [dataSource]="tableDataSource" ngClass.lt-md="small-table-text">
      <!-- noteId Column -->
      <ng-container matColumnDef="noteId">
        <mat-header-cell *matHeaderCellDef fxFlex="11%">
          <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }" i18n="@@quick-pay-payment-amount.table.column-header.note-id"
            >quick-pay-payment-amount.table.column-header.note-id</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="11%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.noteId
        }}</mat-cell>
      </ng-container>
      <!-- nextPaymentDueDate Column -->
      <ng-container matColumnDef="nextPaymentDueDate">
        <mat-header-cell *matHeaderCellDef fxFlex="11%">
          <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }" i18n="@@payment-amount.table.column-header.next-payment-due-date"
            >payment-amount.table.column-header.next-payment-due-date</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="11%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.nextPaymentDueDate
        }}</mat-cell>
      </ng-container>
      <!-- totalAmountDue Column -->
      <ng-container matColumnDef="totalAmountDue">
        <mat-header-cell *matHeaderCellDef fxFlex="11%">
          <span
            class="header-superscript header-after-content-3"
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@quick-pay-payment-amount.table.column-header.total-amount-due"
            >quick-pay-payment-amount.table.column-header.total-amount-due</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="11%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.totalAmountDue | currency
        }}</mat-cell>
      </ng-container>
      <!-- Group Footer -->
      <ng-container matColumnDef="groupFooterTotals">
        <td
          class="mat-cell-group-footer"
          [ngClass]="{ 'mat-column-data-ie': isBrowserIE }"
          style="padding-right: 20px; text-align: right;"
          mat-cell
          *matCellDef="let groupFooter"
          fxFlex="45%"
          fxLayoutAlign="end center"
        >
          <strong><span i18n="@@quick-pay-payment-amount.table.group-footer.pay-group">quick-pay-payment-amount.table.group-footer.pay-group</span>:</strong>
        </td>
      </ng-container>
      <ng-container matColumnDef="groupFooterTotalAmountDueTotal">
        <td
          class="mat-cell-group-footer"
          [ngClass]="{ 'mat-column-data-ie': isBrowserIE }"
          mat-cell
          *matCellDef="let groupFooter"
          fxFlex="11%"
          fxLayoutAlign="start center"
        >
          <strong>{{ groupFooter.totalAmountDueTotal | currency }}</strong>
        </td>
      </ng-container>
      <tr
        mat-row
        class="mat-row-group-footer"
        *matRowDef="
          let row;
          columns: [
            'groupFooterTotals',
            'groupFooterTotalAmountDueTotal'
          ];
          when: isGroupFooter
        "
      ></tr>

      <mat-header-row
        class="primary-light-bg-top-to-bottom-gradient"
        *matHeaderRowDef="tableDisplayedColumns"
        ngClass.lt-md="small-header-row"
      ></mat-header-row>
      <mat-row *matRowDef="let row; columns: tableDisplayedColumns" ngClass.lt-md="small-row"></mat-row>
    </mat-table>

    <div fxLayoutAlign="end center" class="small-display-text primary-light-color" *ngIf="quickpaypaymentSelectedDataFound">
      <app-table-record-count
        [recordCount]="recordCount"
        i18n-singularLabel="@@quick-pay-payment-amount.table.record-count.singular-label"
        singularLabel="quick-pay-payment-amount.table.record-count.singular-label"
        i18n-multipleLabel="@@quick-pay-payment-amount.table.record-count.multiple-label"
        multipleLabel="quick-pay-payment-amount.table.record-count.multiple-label"
      ></app-table-record-count>
    </div>
    <div fxLayout="column" style="margin-top: 16px" *ngIf="quickpaypaymentSelectedDataFound">
      <div *ngIf="isBrowserIE; else quickpaypaymentAmountPostTableFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="quickpaypaymentAmountPostTableFlexColumnTemplate"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #quickpaypaymentAmountPostTableFlexColumnTemplate>
  <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px" *ngIf="quickpaypaymentSelectedDataFound">
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else quickpaypaymentAmountFormFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="quickpaypaymentAmountFormFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div
    fxFlex="100%"
    fxLayout="row"
    fxLayout.lt-md="column"
    fxLayoutGap.lt-md="10px"
    style="margin-top: 16px"
    *ngIf="quickpaypaymentSelectedDataFound"
  >
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else quickpaypaymentAmountOptionsFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="quickpaypaymentAmountOptionsFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxLayout="column" style="margin-top: 16px" *ngIf="quickpaypaymentSelectedDataFound && displayNotices">
    <div *ngIf="isBrowserIE; else quickpaypaymentAmountNoticesFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
      <ng-container *ngTemplateOutlet="quickpaypaymentAmountNoticesFlexColumnTemplate"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #quickpaypaymentAmountFormFlexColumnTemplate>
  <div fxFlex="100%" fxLayoutAlign="center center"  *ngIf="getPayoffAmountComplete">
    <form [formGroup]="quickpaypaymentAmountForm">
      <mat-radio-group class="form-radio-group display-text" [formControl]="selectedPaymentOption">
        <mat-radio-button class="form-radio-button" value="TOTAL" (click)="onRadioButtonClick('TOTAL')">
          <mat-form-field>
            <input
              matInput
              i18n-placeholder="@@quick-pay-payment-amount.form.total-amount-due.label"
              placeholder="quick-pay-payment-amount.form.total-amount-due.label"
              type="text"
              [value]="totalAmountDueValueString"
              autocomplete="off"
              readonly
            />
            <mat-icon
            class="tooltip-icon"
            matTooltip="{{ getToolTip('TotalAmount') }}"
            matTooltipPosition="after"
            matTooltipClass="tooltip-multi-line"
            >help_outline</mat-icon>
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
        </mat-radio-button>
        <mat-radio-button class="form-radio-button" value="CUSTOM" (click)="onRadioButtonClick('CUSTOM')">
          <mat-form-field>
            <input
              matInput
              i18n-placeholder="@@quick-pay-payment-amount.form.custom-payment-amount.label"
              placeholder="quick-pay-payment-amount.form.custom-payment-amount.label"
              type="number"
              [formControl]="customPaymentAmount"
              autocomplete="off"
              onkeypress="return isNumberKey(this, event, 2)"
            />
            <span matPrefix>$&nbsp;
            </span>
            <mat-hint align="end">{{ minimumAmountDueValue | currency }} - {{ maximumAmountDueValue | currency }}
              <span
                  class="radio-superscript header-after-content-5" *ngIf="CompanyCode_Check()"></span>
            </mat-hint>
            <mat-error
              class="form-error"
              *ngIf="customPaymentAmount.hasError('required')"
              i18n="@@quick-pay-payment-amount.form.custom-payment-amount.error.required"
              >quick-pay-payment-amount.form.custom-payment-amount.error.required</mat-error
            >
            <mat-error class="form-error" *ngIf="customPaymentAmount.hasError('min') && !customPaymentAmount.hasError('required')">
              <span i18n="@@quick-pay-payment-amount.form.custom-payment-amount.error.min">quick-pay-payment-amount.form.custom-payment-amount.error.min</span>
              {{ minimumAmountDueValue | currency }}</mat-error
            >
            <mat-error class="form-error" *ngIf="customPaymentAmount.hasError('max') && !customPaymentAmount.hasError('required')">
              <span i18n="@@quick-pay-payment-amount.form.custom-payment-amount.error.max">quick-pay-payment-amount.form.custom-payment-amount.error.max</span>
              {{ maximumAmountDueValue | currency }}</mat-error
            >
          </mat-form-field>
        </mat-radio-button>
      </mat-radio-group>
    </form>
  </div>
</ng-template>

<ng-template #quickpaypaymentAmountOptionsFlexColumnTemplate>
  <div fxFlex="100%" class="display-text" fxLayoutAlign="center center">
    <button
      mat-flat-button
      color="primary"
      (click)="setQuickPayPaymentAmount()"
      [disabled]="!quickpaypaymentAmountForm.valid"
      i18n="@@quick-pay-payment-amount.form.set-button.label"
    >
    quick-pay-payment-amount.form.set-button.label
    </button>
  </div>
</ng-template>

<ng-template #quickpaypaymentAmountNoticesFlexColumnTemplate>
  <div fxFlex="100%" class="display-text"><sup>3</sup>&nbsp;
    <span i18n="@@quick-pay-payment-amount.notices.3">quick-pay-payment-amount.notices.3</span></div>
  <div fxFlex="100%" class="display-text" *ngIf="CompanyCode_Check()">
    <sup>5</sup>&nbsp;<b><span i18n="@@quick-pay-payment-amount.notices.5a">quick-pay-payment-amount.notices.5a</span>&nbsp;
    <a target="_blank" href="https://www.tuitionoptions.com/about-payments">
       <span i18n="@@quick-pay-payment-amount.notices.5b">quick-pay-payment-amount.notices.5b</span>
    </a>&nbsp;
    <span i18n="@@quick-pay-payment-amount.notices.5c">quick-pay-payment-amount.notices.5c</span>
    </b>
  </div>
  <div fxFlex="100%" class="display-text"><sup>*</sup>&nbsp;<span i18n="@@quick-pay-payment-amount.notices.6">quick-pay-payment-amount.notices.6</span></div>
</ng-template>
